module.exports = __webpack_public_path__ + "static/media/clock-icon.5e207845.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clock-icon.svg
// module id = 1469
// module chunks = 0